import { render, staticRenderFns } from "./semCRP.vue?vue&type=template&id=282cc8ce"
import script from "./semCRP.vue?vue&type=script&lang=js"
export * from "./semCRP.vue?vue&type=script&lang=js"
import style0 from "./semCRP.vue?vue&type=style&index=0&id=282cc8ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports